<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="full-width mt-2 d-flex" v-if="compareMode && !hideCompare">
    <h5>{{getPrisonNameFromId(filters.prisonId)}}</h5>
    <div class="ui-spacer"></div>
    <h5>{{getPrisonNameFromId(compareFilters.prisonId)}}</h5>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';

  export default {
    components: {},
    props: {},
    data() {
      return {
        test: '',
      };
    },
    computed: {
      ...mapState({
        filters: state => state.stats.filters,
        compareFilters: state => state.stats.compareFilters,
        compareMode: state => state.stats.compareMode,
        prisons: state => state.stats.prisons,
        hideCompare: state => state.stats.hideCompare,
      }),
    },
    mounted() {

    },
    methods: {
      getPrisonNameFromId(prisonId) {
        const prisonFound = this.prisons.find(prison => prison.prison_id === prisonId);
        return prisonFound ? prisonFound.name : '';
      },
    },
  };
</script>
